export const tooltipDescriptions = {
  // Main Options
  value: "Enter the website URL or text you want your QR code to contain",
  size: "Adjust the size of your QR - larger sizes are easier to scan from a distance",
  logoImage: "Add your brand logo or any image to the center of the QR code",
  maintainAspectRatio: "Keep your logo's shape when resizing (prevents stretching)",
  logoWidth: "Make your logo wider or narrower",
  logoHeight: "Make your logo taller or shorter",
  logoOpacity: "Adjust how see-through your logo appears (0 = invisible, 1 = solid)",
  fgColor: "Choose the color of the QR code patterns (default: black)",
  bgColor: "Pick the background color of your QR code (default: white)",
  qrStyle: "Choose between classic squares or modern dots for your QR patterns",
  logoFile: "Upload a logo image from your device",
  logoUrl: "Paste a direct link to an image on the web",
  rotate: "Rotate your QR code 90 degrees clockwise",
  
  // Advanced Options
  custom: "If checked, disable automatic optimizations. Take full control of all settings (turn off automatic optimizations)",
  ecLevel: "Set how well your QR code can recover from damage or obstruction:\n• L: Basic (7% recovery)\n• M: Standard (15% recovery)\n• Q: Better (25% recovery)\n• H: Best (30% recovery)",
  quietZone: "Add white space around the borders of your QR code to make it easier to scan",
  removeQrCodeBehindLogo: "Hide QR patterns behind your logo for a cleaner look",
  logoPadding: "Add space around your logo to separate it from the QR patterns",
  logoPaddingStyle: "Choose between square or circular space around your logo",
  
  // Eye Customization
  eyeRadius: "Round the corners of the three square patterns in the corners",
  eyeColor: "Customize the color of the three square patterns in the corners (inner and outer parts can be different)",
  eyesCircleButton: "Turn all the Eyes to a Circle", 
  eyesSquareButton: "Turn all the Eyes to a Square"
}